<template>
    <ion-toolbar>
        <ion-buttons slot="start" v-if="$store.state.pages.auth.back.length">
            <ion-button class="button_back" data-testid="directions-127" @click="goBack">
                <ion-icon name="arrow-back-outline"></ion-icon>
            </ion-button>
        </ion-buttons>
        <ion-buttons slot="end">
            <ion-button @click="skip" class="pill next-pill-button">
                <span>Skip</span>
            </ion-button>
        </ion-buttons>
    </ion-toolbar>

    <div class="main_wrapper ion-padding">
        <div class="container">
            <div class="auth-header">
                <div class="auth-heading">
                    <h1>Identity Documents</h1>
                </div>
                <div class="brand-icon">
                    <SvgIcon name="brandIcon" width="32" height="32" viewBox="0 0 32 32" fill="none" />
                </div>
            </div>

            <el-form class="full_page" :model="form" ref="userForm" label-position="top">
                <el-form-item prop="hasCorporation" label="Do you have a corporation?">
                    <el-select v-model="form.hasCorporation" placeholder="Please select one" style="width: 100%"
                        popper-class="normal-select">
                        <el-option label="Yes" :value="1" />
                        <el-option label="No" :value="0" />
                    </el-select>
                </el-form-item>
                <div v-if="form.hasCorporation">
                    <div class="py-2 mt-3">
                        Upload your Certificate of Incorporation.
                    </div>
                    <div class="pharmacy-license-label">Certificate of Incorporation</div>
                    <div class="insurance-type-input">
                        <el-form-item :error="v$.certificateOfIncorporationFiles.$error" :show-message="false" label=""
                            prop="certificateOfIncorporationFiles">
                            <el-upload class="uploader-support" :action="'upload'"
                                v-model:file-list="form.certificateOfIncorporationFiles"
                                name="form.certificateOfIncorporationFiles" list-type="picture" :thumbnail-mode="true"
                                :limit="3" :on-preview="cropperMethods.handlePreview"
                                :on-exceed="cropperMethods.handleExceed" :drag="true"
                                :on-change="cropperMethods.handleChange"
                                :before-upload="cropperMethods.beforeAvatarUpload">
                                <svg width="54" height="54" viewBox="0 0 54 54" fill="none"
                                    xmlns="http://www.w3.org/2000/svg">
                                    <path d="M27 4.5V18L31.5 13.5" stroke="black" stroke-width="2"
                                        stroke-linecap="round" stroke-linejoin="round" />
                                    <path d="M27 18L22.5 13.5" stroke="black" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path
                                        d="M15.75 27C6.75 27 6.75 31.0275 6.75 36V38.25C6.75 44.46 6.75 49.5 18 49.5H36C45 49.5 47.25 44.46 47.25 38.25V36C47.25 31.0275 47.25 27 38.25 27C36 27 35.37 27.4725 34.2 28.35L31.905 30.78C29.25 33.615 24.75 33.615 22.0725 30.78L19.8 28.35C18.63 27.4725 18 27 15.75 27Z"
                                        stroke="black" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path d="M11.25 26.9998V17.9998C11.25 13.4773 11.25 9.74234 18 9.08984"
                                        stroke="black" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                    <path d="M42.75 26.9998V17.9998C42.75 13.4773 42.75 9.74234 36 9.08984"
                                        stroke="black" stroke-width="2" stroke-miterlimit="10" stroke-linecap="round"
                                        stroke-linejoin="round" />
                                </svg>
                                <div class="cv-upload-title">Browse Your Files</div>
                                <div class="cv-upload-info">You can only upload file with JPG JPEG PNG JFIF SVG or PDF
                                    formats and
                                    also file
                                    maximum size 10MB.</div>
                                <template #file="{ file }">
                                    <div class="wrap-fd">
                                        <div v-if="file.raw.type == 'application/pdf'"
                                            style="display: flex; align-items: center;">
                                            <span class="locumate_icons locumate_icon-picture"></span>
                                            <span class="mx-2" size="large">{{ file.name }}</span>
                                        </div>
                                        <div v-else>
                                            <img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
                                        </div>
                                        <span class="el-upload-list__item-actions">
                                            <span class="el-upload-list__item-delete"
                                                @click="cropperMethods.handleRemove(file)">
                                                <i class="el-icon-close"></i>
                                            </span>
                                        </span>
                                    </div>
                                </template>
                            </el-upload>
                            <el-form-item-error v-if="v$.certificateOfIncorporationFiles.$error">{{
                                v$.certificateOfIncorporationFiles.$errors[0].$message
                                }}</el-form-item-error>
                        </el-form-item>
                    </div>
                </div>
                <!-- Button to submit the form -->
                <el-form-item class="button_submit mb0">
                    <el-button class="submit" type="primary" data-testid="directions-129" :disabled="isSubmitDisabled"
                        @click="handleSubmit">
                        Next
                    </el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>

<script>
import { ref, computed, onMounted, inject } from 'vue'
import { useVuelidate } from '@vuelidate/core'
// import { required } from '@vuelidate/validators'
import { helpers, requiredIf, required } from '@vuelidate/validators'
import { useRouter, useRoute } from 'vue-router'
import { useStore } from 'vuex'
import FileHelpers from "@/helpers/file/file";
import { ElMessage, ElMessageBox } from "@/components/Vendor/Element";
import SvgIcon from '@/components/Svg/SvgIcon.vue'; 



export default {components: {
        SvgIcon
    },
    setup() {
        const $store = useStore()
        const $router = useRouter()
        const $route = useRoute()
        const setPageClassGlobal = inject(['setPageClassGlobal']);
        const form = ref({
            hasCorporation: 0,
            certificateOfIncorporationFiles: ref([]),
        })
        const fileHelpers = new FileHelpers();

        const rules = computed(() => {
            return {
                hasCorporation: {
                    required: helpers.withMessage('Please select one', required)
                },
                certificateOfIncorporationFiles: {
                    required: helpers.withMessage('Certificate of incorporation is required when you have corporation', requiredIf(() => form.value.hasCorporation)),
                },
            };
        });

        const v$ = useVuelidate(rules, form)

        const isSubmitDisabled = computed(() => {
            return Object.values(form.value).some(value => value === null) || v$.value.$pending || v$.value.$error;
        });

        const validateField = fieldName => v$.value[fieldName].$touch()

        const goBack = () => {
            $router.push({
                name: 'auth_identity_document'
            })
        };

        const handleSubmit = async () => {
            const result = await v$.value.$validate();
            console.log("🚀 ~ handleSubmit ~ result:", form);
            if (!result) {
                alert('The form has errors');
                return;
            }

            $store.dispatch('addAuthPageBack', $route.name);

            // Extract file data from the form object
            const fileData = {
                certificateOfIncorporationFiles: form.value.certificateOfIncorporationFiles,
            };

            const formData = new FormData();

            // Iterate over each type of file and append it to FormData
            if (form.value.hasCorporation == 0) {
                fileData.certificateOfIncorporationFiles = null;
            } else {
                for (const fileType in fileData) {
                    const files = fileData[fileType];
                    let counter = 0;

                    if (files && files.length > 0) {
                        files.forEach((file) => {
                            formData.append(`file[${fileType}][${counter}]`, file.raw);
                            counter++;
                        });
                    }
                }
            }

            // Extract other form data
            formData.append('has_corporation', (form.value.hasCorporation));

            (async () => {
                try {
                    // Call your Vuex store dispatch
                    await $store.dispatch('SAVE_USER_DATA', formData);

                    // After dispatching, you can perform any additional actions
                    $router.push({
                        name: 'auth_id_eligibility',
                    });
                } catch (error) {
                    console.error('Error submitting form:', error);
                }
            })();

            // alert('Form submitted successfully');
        }

        onMounted(() => {
            setPageClassGlobal('global_auth_page')
        })

        const cropperMethods = {
            beforeAvatarUpload(file) {
                const img = URL.createObjectURL(file.raw);
                // form.files.push(img);
                console.log(img);
            },
            handleRemove(file) {
                form.value.certificateOfIncorporationFiles.splice(form.value.certificateOfIncorporationFiles.indexOf(file), 1);
                validateField('professionalExpireDate');
                validateField('certificateOfIncorporationFiles');
            },
            handleChange(file, fileList) {
                const type = fileHelpers.getFileType(file);
                if (type == "image" || type == "pdf") {
                    // form.files.push(file);
                    form.value.certificateOfIncorporationFiles = fileList;
                    console.log("🚀 ~ handleChange ~ form.files2:", form.certificateOfIncorporationFiles)
                    validateField('professionalExpireDate');
                } else {
                    fileList.pop();
                    form.certificateOfIncorporationFiles = null;
                    ElMessage({
                        type: "error",
                        message: `Document must be JPG JPEG PNG JFIF or PDF format!`,
                    });
                }
            },
            handlePreview(/*file*/) { },
            handleExceed(file, files) {
                ElMessage({
                    type: "error",
                    message: `You can upload 1 document, you selected ${files.length} `,
                });
            },
        };

        const skip = () => {
            (async () => {
                try {
                    await ElMessageBox.confirm(
                        ``,
                        "Do you want to skip? You will be unverified",
                        {
                            distinguishCancelAndClose: true,
                            showConfirmButton: true,
                            confirmButtonText: "Skip",
                            cancelButtonText: "Cancel",
                            confirmButtonClass: "el-button--green",
                            cancelButtonClass: "el-button--grey",
                            showClose: true,
                        }
                    );
                } catch {
                    return;
                }
                try {
                    await $store.dispatch("addAuthPageBack", $route.name);
                    $router.push({
                      name: "auth_id_eligibility",
                    });
                } catch (error) {
                    console.log(error);
                }
            })();
        };

        return {
            form,
            v$,
            isSubmitDisabled,
            validateField,
            goBack,
            handleSubmit,
            cropperMethods,
            rules,
            skip
        }
    }
}
</script>